export const youtubeBaseUrl = 'https://www.youtube.com/embed';
export const vimeoBaseUrl = 'https://player.vimeo.com/video';
